module.exports = __webpack_public_path__ + "img/audio.30d6a8a1.svg";